module.exports = __webpack_public_path__ + "img/cerroAmigos.42a31fc8.jpg";